import React, { useState, useEffect } from 'react';
import { Button, List, Row, Col, Typography, Modal, Input } from 'antd';
import useGraphqlService from "../../../util/useGraphqlService";
import { BROADCAST_SCREEN_UPDATE } from "../../../constants/graphql/screenQueries";
import { useEpisode } from "../../../contexts/EpisodeContext";
import moment from "moment";
import { GET_EPISODE_QUERY } from "../../../constants/graphql/episodeQueries";
import StyledListItem from "../../styled/StyledListItem";

const ScreenControl = () => {
    const { sendGraphqlRequest } = useGraphqlService();
    const [bucketPulls, setBucketPulls] = useState([]);
    const [selectedBucketPull, setSelectedBucketPull] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [customMessage, setCustomMessage] = useState('');
    const { episode } = useEpisode();

    useEffect(() => {
        if (episode?.id) {
            fetchEpisodeData();
        }
    }, [episode]);

    const fetchEpisodeData = async () => {
        try {
            const data = await sendGraphqlRequest(GET_EPISODE_QUERY, { id: episode?.id });
            setBucketPulls(data?.episode?.bucketPulls);
        } catch (error) {
            console.error('Failed to fetch episode details:', error);
        }
    };

    const defaultActions = [
        { name: "Standby", value: { type: 'Standby' } },
        { name: "Show Start", value: { type: 'showStart' } },
        { name: "Show End", value: { type: 'showEnd' } },
        { name: "Custom Message", value: { type: 'customMessage' } }
    ];

    const handleActionClick = (action) => {
        setSelectedBucketPull(null);  // Deselect the selectedBucketPull
        if (action.type === 'customMessage') {
            setIsModalVisible(true);
        } else {
            handleConfirm(action);
        }
    };

    const handleBucketPullSelect = (item) => {
        setSelectedBucketPull(prevSelected =>
            prevSelected && prevSelected.entry?.id === item.id ? null : { type: 'bucketPull', entry: { ...item } }
        );
    };

    const handleConfirm = async (payload) => {
        try {
            await sendGraphqlRequest(BROADCAST_SCREEN_UPDATE, { input: { payload: payload || selectedBucketPull } });
            console.log("Payload submitted:", payload || selectedBucketPull);
            setSelectedBucketPull(null); // Clear selection after broadcast
        } catch (error) {
            console.error("Failed to submit payload:", error);
        }
    };

    return (
        <Row gutter={16}>
            <Col span={6}>
                <List
                    header={<div>Default Actions</div>}
                    grid={{ gutter: 16, column: 1 }}
                    dataSource={defaultActions}
                    renderItem={item => (
                        <List.Item>
                            <Button block onClick={() => handleActionClick(item.value)} style={{ height: 50 }}>
                                {item.name}
                            </Button>
                        </List.Item>
                    )}
                />
            </Col>
            <Col span={6}>
                <List
                    header={<div>Bucket Pulls</div>}
                    itemLayout="horizontal"
                    dataSource={bucketPulls}
                    renderItem={item => (
                        <StyledListItem
                            key={item.id}
                            onClick={() => handleBucketPullSelect(item)}
                            style={{ backgroundColor: selectedBucketPull?.entry?.id === item.id ? 'red' : 'black' }}
                        >
                            <List.Item.Meta
                                title={<Typography.Text>{item.paperName}</Typography.Text>}
                                description={`Pulled at: ${moment(item.pulledAt).format('HH:mm:ss')}`}
                            />
                        </StyledListItem>
                    )}
                />
            </Col>
            <Col span={12}>
                {selectedBucketPull && (
                    <Button type="primary" size="large" onClick={() => handleConfirm()} block style={{ marginTop: 8 }}>
                        Send to Screen
                    </Button>
                )}
                <Modal
                    title="Enter Custom Message"
                    visible={isModalVisible}
                    onOk={() => {
                        handleConfirm({ type: "customMessage", message: customMessage });
                        setIsModalVisible(false);
                    }}
                    onCancel={() => setIsModalVisible(false)}
                >
                    <Input
                        placeholder="Type your message here"
                        onChange={(e) => setCustomMessage(e.target.value)}
                        value={customMessage}
                    />
                </Modal>
            </Col>
        </Row>
    );
};

export default ScreenControl;